export { default } from './LicensesList';
